import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { useIsCustomerMode } from '@plato/app-core/hooks/use-customer-mode';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { LineItemRowBase, LineItemRowCell } from './line-items.tsx';

export function LineItemHeader(): ReactElement {
    const { t } = useTranslation('sales-draft');
    const customerViewToggled = useIsCustomerMode();
    const { canReadGrossMargin, canReadTransactionGrossMargin, canReadLineItemRebate } = useAppConfig();

    return (
        <LineItemRowBase header>
            <LineItemRowCell header>{t('sales_draft__line_items__table_header__article')}</LineItemRowCell>
            <LineItemRowCell header right>
                {t('sales_draft__line_items__table_header__quantity')}
            </LineItemRowCell>
            <LineItemRowCell header right>
                {t('sales_draft__line_items__table_header__price')}
            </LineItemRowCell>
            {canReadLineItemRebate && (
                <LineItemRowCell header right>
                    {t('sales_draft__line_items__table_header__rebate')}
                </LineItemRowCell>
            )}
            {canReadGrossMargin && canReadTransactionGrossMargin && !customerViewToggled && (
                <LineItemRowCell header right>
                    {t('sales_draft__line_items__table_header__gross_margin_percent')}
                </LineItemRowCell>
            )}
            <div className="w-10" />
        </LineItemRowBase>
    );
}
